interface SectionHeaderProps {
  iconSrc: string;
  iconAlt: string;
  title: string;
  titleTag?: 'h1' | 'h2' | 'h3';
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  iconSrc,
  iconAlt,
  title,
  titleTag = 'h2',
  className = '',
}) => {
  const TitleTag = titleTag;

  return (
    <div className={`mb-6 flex items-center gap-3 ${className}`}>
      <div className='flex items-center justify-center'>
        <img
          src={iconSrc}
          alt={iconAlt}
          className='relative mx-auto size-[8vw] md:size-[4vw] lg:size-[2vw]'
        />
      </div>
      <TitleTag className='text-xl font-bold'>{title}</TitleTag>
    </div>
  );
};

export default SectionHeader;
